var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "m1.8 13.7 1.3-1.3V22h18v-9.6l1.3 1.3 1.4-1.4L12.1.6l-5 5V4h-2v3.6L.4 12.3zm17.3-3.3V20h-14v-9.6l7-7z"
  })));
};
export default SvgHome;